﻿$(document).ready(function () {
    if ($("div#divAOPAAircraftInformationUpdate").length) {
        $('#InsuranceExpireDate').datepicker({
            changeMonth: true,
            changeYear: true
        });
     }
});
